var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _timeBase, _startedAt, _pausedAt, _paused, _wasPaused, _lastFrameAt, _timeF;
export class PlayerTime {
    constructor() {
        _timeBase.set(this, 0);
        _startedAt.set(this, 0);
        _pausedAt.set(this, 0);
        _paused.set(this, false);
        _wasPaused.set(this, false);
        _lastFrameAt.set(this, 0);
        _timeF.set(this, 1);
    }
    setPaused(paused) {
        __classPrivateFieldSet(this, _paused, paused);
        if (paused) {
            __classPrivateFieldSet(this, _pausedAt, __classPrivateFieldGet(this, _lastFrameAt));
            __classPrivateFieldSet(this, _wasPaused, true);
        }
    }
    setTimeScale(s) {
        const oldDelta = __classPrivateFieldGet(this, _timeF) * (__classPrivateFieldGet(this, _lastFrameAt) - __classPrivateFieldGet(this, _startedAt) + __classPrivateFieldGet(this, _timeBase));
        const newDelta = s * (__classPrivateFieldGet(this, _lastFrameAt) - __classPrivateFieldGet(this, _startedAt) + __classPrivateFieldGet(this, _timeBase));
        __classPrivateFieldSet(this, _timeBase, __classPrivateFieldGet(this, _timeBase) + (oldDelta - newDelta) / s);
        __classPrivateFieldSet(this, _timeF, s);
    }
    wallClockToLocalTime(timestamp) {
        return __classPrivateFieldGet(this, _timeF) * (timestamp - __classPrivateFieldGet(this, _startedAt) + __classPrivateFieldGet(this, _timeBase));
    }
    wallClockBeat(timestamp) {
        if (__classPrivateFieldGet(this, _paused)) {
            timestamp = __classPrivateFieldGet(this, _pausedAt);
        }
        this.trackTime(timestamp);
        return this.wallClockToLocalTime(timestamp);
    }
    trackTime(timestamp) {
        if (__classPrivateFieldGet(this, _startedAt) === 0) {
            __classPrivateFieldSet(this, _startedAt, timestamp);
        }
        if (__classPrivateFieldGet(this, _wasPaused) && !__classPrivateFieldGet(this, _paused)) {
            if (__classPrivateFieldGet(this, _pausedAt) > 0) {
                const pauseDuration = timestamp - __classPrivateFieldGet(this, _pausedAt);
                __classPrivateFieldSet(this, _timeBase, __classPrivateFieldGet(this, _timeBase) - pauseDuration);
            }
            __classPrivateFieldSet(this, _wasPaused, false);
        }
        __classPrivateFieldSet(this, _lastFrameAt, timestamp);
    }
}
_timeBase = new WeakMap(), _startedAt = new WeakMap(), _pausedAt = new WeakMap(), _paused = new WeakMap(), _wasPaused = new WeakMap(), _lastFrameAt = new WeakMap(), _timeF = new WeakMap();
